import React from 'react';
import moment from 'moment';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Socials from '../common/Socials';

export default function Footer(): JSX.Element {
  return (
    <footer>
      <Container maxWidth="xl">
        <Box sx={{ py: { xs: 6 }, px: { xs: 1, sm: 3 } }}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item>
              <Socials />
              <Box mt={3}>
                <Typography variant="subtitle1" align="center">
                  © 2010 - {moment().year()}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </footer>
  );
}
